import React, { Component } from 'react';
import './styles.css';
import routeRegistry from '../../../../registries/RouteRegistry';

import { connect } from 'react-redux';
import browserHistory from '../../../../stores/browserHistory';

import {
  __DEV__,
  extractRelativeUrl,
  resolvePublicAssets,
} from '../../../../utils';
import { t } from '../../../../locales';

interface BackNavButtonProps {
  previousTitle: string | undefined;
  onPopTitle: () => void;
  isHideBackButton: boolean;
}

interface BackNavButtonState {
  routeRoot?: string;
}

class BackNavButton extends Component<BackNavButtonProps, BackNavButtonState> {
  pageTop: any;
  componentDidMount() {
    browserHistory.listen(() => {
      this.forceUpdate();
    });
  }

  scrollToTop = () => {
    if (this.pageTop) {
      this.pageTop.scrollIntoView({ behavior: 'auto' });
    }
  };
  componentDidUpdate() {
    this.scrollToTop();
  }

  getRouteRoot() {
    const routeMap = routeRegistry.getScreens();
    const routes = Object.keys(routeMap);

    const relativeUrl = extractRelativeUrl();
    const routeRoot = routes
      .filter((r) => !!routeMap[r].sidebarItem)
      .find((r) => relativeUrl.startsWith(r));

    return routeRoot;
  }

  getBackTitle() {
    return `${t('BACK')}${`${t('SPACE')}${t('TO')}${t('SPACE')}${t(
      'HOME_LABEL',
    ).toUpperCase()}`}`;
  }

  goBack() {
    browserHistory.push(`/home`);
  }

  render() {
    const backTitle = this.getBackTitle();

    return (
      <div>
        <div
          ref={(el) => {
            this.pageTop = el;
          }}
        ></div>
        {
          <nav className="back-nav">
            <span
              className="cursor-pointer"
              onClick={() => {
                this.goBack();
              }}
              data-enable-ga
              data-ga-type="button"
            >
              <img
                className={`left-arrow`}
                src={resolvePublicAssets(
                  `/assets/images/drop-down-arrow-blue.svg`,
                )}
              />
              {backTitle}
            </span>
          </nav>
        }
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  BackNavButton.mapStateToProps,
  BackNavButton.mapDispatchToProps,
)(BackNavButton);
